import { render, staticRenderFns } from "./ChatEasySaude.vue?vue&type=template&id=0dfebe5b&scoped=true"
import script from "./ChatEasySaude.vue?vue&type=script&lang=js"
export * from "./ChatEasySaude.vue?vue&type=script&lang=js"
import style0 from "./ChatEasySaude.vue?vue&type=style&index=0&id=0dfebe5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfebe5b",
  null
  
)

export default component.exports